"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLinkedLineData = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getWrappedHotelLines_1 = require("./getWrappedHotelLines");
const isSummaryItem_1 = require("./isSummaryItem");
const getLinkedOrderLines_1 = require("./getLinkedOrderLines");
const getLinkedLineData = (line, items) => {
    if (!line.versions)
        return null;
    const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(line.versions);
    if (!latest_version)
        return null;
    const { type } = line;
    const { config } = latest_version;
    switch (type) {
        case "GOLF": {
            const golf_config = config;
            const hotel_lines = (0, getWrappedHotelLines_1.getWrappedHotelLines)(golf_config.where_when_who.date, items);
            const hasHotelLine = items.some((item) => {
                if (item.type === "HOTEL")
                    return true;
                return false;
            });
            const golf_lines_with_linked_transfers = items.filter((item) => {
                if (item.type !== "GOLF")
                    return false;
                if ((0, isSummaryItem_1.isSummaryItem)(item))
                    return false;
                if (!item.versions)
                    return false;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
                if (!latest_version)
                    return false;
                const g_config = latest_version.config;
                if (g_config?.where_when_who?.region_id ===
                    golf_config?.where_when_who?.region_id) {
                    return true;
                }
                return false;
            });
            const order_lines = items.filter((item) => {
                if ((0, isSummaryItem_1.isSummaryItem)(item))
                    return false;
                return true;
            });
            // need to cancel all linked lines
            let linked_lines = [];
            golf_lines_with_linked_transfers.forEach((golf_line) => {
                linked_lines = linked_lines.concat((0, getLinkedOrderLines_1.getLinkedOrderLines)(order_lines, golf_line.id));
            });
            linked_lines = linked_lines?.filter((item) => {
                if (item.type !== "TRANSFER")
                    return false;
                if ((0, isSummaryItem_1.isSummaryItem)(item))
                    return false;
                if (!item.versions)
                    return false;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(item.versions);
                if (!latest_version)
                    return false;
                const transfer_config = latest_version.config;
                if (transfer_config.transfer_legs?.outbound?.from_type === "Airport") {
                    return false;
                }
                return true;
            });
            const additional_config = {};
            // get all non summary hotel lines
            let course_name = "";
            if (golf_config.course.name) {
                course_name = golf_config.course.name.en;
            }
            const hotel_line = hotel_lines.length === 1 ? hotel_lines[0] : null;
            let hotel_config = null;
            if (hotel_line) {
                if ((0, isSummaryItem_1.isSummaryItem)(hotel_line))
                    break;
                if (!hotel_line.versions)
                    break;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(hotel_line.versions);
                if (!latest_version)
                    break;
                hotel_config = latest_version.config;
                if (!hotel_config?.where_when_who?.hotel)
                    break;
                additional_config.outbound_from_area =
                    hotel_config?.where_when_who?.hotel?.id;
                additional_config.outbound_from_name =
                    hotel_config?.where_when_who?.hotel?.name?.en;
                additional_config.outbound_from_type = "Hotel";
                additional_config.inbound_to_area =
                    hotel_config.where_when_who?.hotel?.id;
                additional_config.inbound_to_name =
                    hotel_config.where_when_who?.hotel?.name?.en;
                additional_config.inbound_to_type = "Hotel";
            }
            let golf_pickup_area = null;
            if (hotel_lines.length > 0) {
                golf_pickup_area = hotel_config?.where_when_who?.hotel?.id;
            }
            else if (linked_lines && linked_lines?.length > 0 && !hasHotelLine) {
                // get the first one
                const transfer_line = linked_lines[0];
                if (!transfer_line.versions)
                    break;
                const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(transfer_line.versions);
                if (!latest_version)
                    break;
                const transfer_config = latest_version.config;
                golf_pickup_area = transfer_config.transfer_legs?.outbound?.from_area;
                additional_config.outbound_from_area =
                    transfer_config.transfer_legs?.outbound?.from_area;
                additional_config.outbound_from_name =
                    transfer_config.transfer_legs?.outbound?.from_name;
                additional_config.outbound_from_type =
                    transfer_config.transfer_legs?.outbound?.from_type;
                additional_config.inbound_to_area =
                    transfer_config.transfer_legs?.inbound?.to_area;
                additional_config.inbound_to_name =
                    transfer_config.transfer_legs?.inbound?.to_name;
                additional_config.inbound_to_type =
                    transfer_config.transfer_legs?.inbound?.to_type;
            }
            return {
                start_date: dayjs(golf_config.where_when_who.date).format("YYYY-MM-DD"),
                end_date: dayjs(golf_config.where_when_who.date).format("YYYY-MM-DD"),
                region_id: golf_config.where_when_who.region_id,
                pickup_area_id: golf_pickup_area,
                linked_line_id: line.id,
                number_of_passengers: golf_config.where_when_who.number_of_golfers,
                outbound_to_area: golf_config.course.id,
                outbound_to_name: course_name,
                outbound_to_type: "Course",
                inbound_from_area: golf_config.course.id,
                inbound_from_name: course_name,
                inbound_from_type: "Course",
                ...additional_config,
            };
        }
        case "HOTEL": {
            const hotel_config = config;
            return {
                start_date: dayjs(hotel_config.where_when_who?.check_in_date).format("YYYY-MM-DD"),
                end_date: dayjs(hotel_config.where_when_who?.check_in_date)
                    .add(hotel_config.where_when_who?.number_of_nights, "day")
                    .format("YYYY-MM-DD"),
                region_id: hotel_config?.where_when_who?.region_id,
                linked_line_id: line.id,
                number_of_passengers: hotel_config?.where_when_who?.number_of_guests,
                outbound_to_area: hotel_config?.where_when_who?.hotel?.id,
                outbound_to_name: hotel_config?.where_when_who?.hotel?.name?.en,
                outbound_to_type: "Hotel",
                inbound_from_area: hotel_config?.where_when_who?.hotel?.id,
                inbound_from_name: hotel_config?.where_when_who?.hotel?.name?.en,
                inbound_from_type: "Hotel",
            };
            break;
        }
        case "TRANSFER": {
            //const transfer_config = config as unknown as TransferOrderLine;
            break;
        }
        case "EXCURSION": {
            //const excursion_config = config as unknown as ExcursionOrderLine;
            break;
        }
        case "CUSTOM": {
            //const custom_config = config as unknown as CustomOrderLine;
            return {};
            break;
        }
    }
};
exports.getLinkedLineData = getLinkedLineData;
